import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';

type Props = {
  title: string
  heroData: any
}
function Hero({ heroData, title }:Props) {
  const heroImage = heroData?.image
    ? getImage(heroData?.image.gatsbyImageData)
    : null;
  const heroImageTextOverlay = heroData?.textOverlayImage
    ? getImage(heroData?.textOverlayImage.gatsbyImageData)
    : null;
  const heroCSS = (cssText: string) => {
    try {
      const css = JSON.parse(cssText);
      css.height = '250px';
      css.width = '100%';
      return css;
    } catch {
      return {};
    }
  };

  return (
    <>
      {heroImage && heroImageTextOverlay
        && (
        <div style={heroCSS(heroData.backgroundGradientCss.backgroundGradientCss)} className="flex justify-center">
          <GatsbyImage image={heroImageTextOverlay} alt={heroData?.textOverlayImage?.description || title} className="hidden h-full max-xl-c:block" />
          <GatsbyImage image={heroImage} alt={heroData?.image?.description || title} className="h-full" />
        </div>
        )}
      {heroImage && !heroImageTextOverlay
      && (
      <div style={heroCSS(heroData.backgroundGradientCss.backgroundGradientCss)} className="flex justify-center">
        <GatsbyImage image={heroImage} alt={title} className="h-full" />
      </div>
      )}
    </>
  );
}

export default Hero;
